module.exports = __webpack_public_path__ + "img/travel2.6cf0ce31.png";